import React from "react";
import mobile from "../../images/mobile.webp";
import playstation from "../../images/playstation.webp";
import headphone from "../../images/headphone.webp";
import barcodescanner from "../../images/barcodescanner.jpg";
import laptop from "../../images/laptop.jpg";
import camera from "../../images/camera.png";
import Smartwatch from "../../images/smartwatch.jpeg";
import BluetoothSpeaker from "../../images/bluetoothSpeaker.jpeg";
import Tablet from "../../images/tablet.jpeg";
import Monitor from "../../images/Monitor.jpeg";
import Keyboard from "../../images/Keyboard.jpeg";
import Mouse from "../../images/Mouse.jpeg";
import Printer from "../../images/Printer.jpeg";
import WiFiRouter from "../../images/WiFi Router.jpeg";
import Projector from "../../images/Projector.jpeg";
import Drone from "../../images/Drone.jpg";
import GamingChair from "../../images/Gaming Chair.jpeg";
import Microphone from "../../images/Microphone.jpeg";
import ExternalHDD from "../../images/External HDD.jpeg";
import PowerBank from "../../images/Power Bank.jpeg";

const ProductDetails = [
  {
    id: 1,
    img: mobile,
    name: "Mobile",
    modelName: "OnePlus 11 5G",
    modelNo: "CPH2447",
    modelYear: "2023",
    price: "₹ 59,999",
  },
  {
    id: 2,
    img: playstation,
    name: "PlayStation",
    modelName: "Sony PlayStation 5",
    modelNo: "CFI-1108A",
    modelYear: "2023",
    price: "₹ 49,990",
  },
  {
    id: 3,
    img: headphone,
    name: "Headphone",
    modelName: "Sony WH-1000XM4",
    modelNo: "WH-1000XM4",
    modelYear: "2022",
    price: "₹ 24,990",
  },
  {
    id: 4,
    img: barcodescanner,
    name: "Barcode Scanner",
    modelName: "Honeywell Voyager",
    modelNo: "1250g",
    modelYear: "2021",
    price: "₹ 5,500",
  },
  {
    id: 5,
    img: laptop,
    name: "Laptop",
    modelName: "Dell Inspiron 15",
    modelNo: "3511",
    modelYear: "2023",
    price: "₹ 58,000",
  },
  {
    id: 6,
    img: camera,
    name: "Camera",
    modelName: "Canon EOS 1500D",
    modelNo: "EOS1500D",
    modelYear: "2023",
    price: "₹ 32,999",
  },
  {
    id: 7,
    img: Smartwatch,
    name: "Smartwatch",
    modelName: "OnePlus Watch",
    modelNo: "W501",
    modelYear: "2022",
    price: "₹ 9,999",
  },
  {
    id: 8,
    img: BluetoothSpeaker,
    name: "Bluetooth Speaker",
    modelName: "JBL Flip 6",
    modelNo: "FLIP6",
    modelYear: "2023",
    price: "₹ 8,490",
  },
  {
    id: 9,
    img: Tablet,
    name: "Tablet",
    modelName: "Samsung Galaxy Tab S8",
    modelNo: "SM-X706",
    modelYear: "2022",
    price: "₹ 49,999",
  },
  {
    id: 10,
    img: Monitor,
    name: "Monitor",
    modelName: "LG UltraGear 27",
    modelNo: "27GP850",
    modelYear: "2023",
    price: "₹ 29,990",
  },
  {
    id: 11,
    img: Keyboard,
    name: "Keyboard",
    modelName: "Logitech MX Keys",
    modelNo: "MX-KEYS",
    modelYear: "2021",
    price: "₹ 11,999",
  },
  {
    id: 12,
    img: Mouse,
    name: "Mouse",
    modelName: "Logitech MX Master 3",
    modelNo: "MX-3",
    modelYear: "2020",
    price: "₹ 7,499",
  },
  {
    id: 13,
    img: Printer,
    name: "Printer",
    modelName: "HP LaserJet Pro",
    modelNo: "MFP M428fdw",
    modelYear: "2022",
    price: "₹ 34,500",
  },
  {
    id: 14,
    img: WiFiRouter,
    name: "WiFi Router",
    modelName: "TP-Link Archer AX50",
    modelNo: "AX50",
    modelYear: "2021",
    price: "₹ 8,999",
  },
  {
    id: 15,
    img: Projector,
    name: "Projector",
    modelName: "Epson Home Cinema",
    modelNo: "EH-TW740",
    modelYear: "2022",
    price: "₹ 44,990",
  },
  {
    id: 16,
    img: Drone,
    name: "Drone",
    modelName: "DJI Mini 3",
    modelNo: "MINI3",
    modelYear: "2023",
    price: "₹ 49,999",
  },
  {
    id: 17,
    img: GamingChair,
    name: "Gaming Chair",
    modelName: "Secretlab Titan",
    modelNo: "TITAN-2022",
    modelYear: "2022",
    price: "₹ 34,999",
  },
  {
    id: 18,
    img: Microphone,
    name: "Microphone",
    modelName: "Blue Yeti",
    modelNo: "YETI",
    modelYear: "2020",
    price: "₹ 12,999",
  },
  {
    id: 19,
    img: ExternalHDD,
    name: "External HDD",
    modelName: "Seagate Backup Plus",
    modelNo: "STHPX5000400",
    modelYear: "2021",
    price: "₹ 5,299",
  },
  {
    id: 20,
    img: PowerBank,
    name: "Power Bank",
    modelName: "Mi 20000mAh",
    modelNo: "PLM11ZM",
    modelYear: "2022",
    price: "₹ 2,499",
  },
];

export default ProductDetails;
